<div class="flex items-center justify-center dialog-header ">
    Update Bulk {{title}}

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">

    <h5>
        Selected {{title}}: {{ selectedProducts?.length }}
    </h5>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6" *ngIf="isRegistration || isApplication || isLeads">

        <div class="col-span-1">
            <label class="block mb-2 ">Assinged to</label>
            <p-select appendTo="body" class="w-full" [(ngModel)]="createFieldFormValue['assigned_to']"
                name="assigned_to" [options]="users"></p-select>
        </div>

        <!-- Pipeline Selection - Only for Leads -->
        <div class="col-span-1" *ngIf="isLeads && !isRegistration && !isApplication">
            <label class="block mb-2">Pipeline</label>
            <p-select class="w-full" appendTo="body" 
                [(ngModel)]="createFieldFormValue['pipeline_id']" 
                name="pipeline_id"
                [options]="pipelineStages"
                optionLabel="label"
                optionValue="value"
                (onChange)="onPipelineChange($event)"
                placeholder="Select Pipeline">
            </p-select>
        </div>

        <div *ngIf="isFixedColumn && !isRegistration && !isApplication && !isEnrollment" class="col-span-1">
            <label class="block mb-2 requiredValue">Query Type</label>
            <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['query_type']" name="query_type"
                [options]="queryTypes" />
        </div>

        <div class="col-span-1" *ngIf="isFixedColumn">
            <label class="block mb-2 requiredValue">Source</label>
            <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['source']" name="source"
                [options]="leadSources"></p-select>


        </div>
        <div class="col-span-1" *ngIf="isFixedColumn && !isRegistration && !isApplication && !isEnrollment">
            <label class="block mb-2 requiredValue">Lead Type</label>
            <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['lead_type']" name="lead_type"
                [options]="leadTypes"></p-select>


        </div>
        <div class="col-span-1" *ngIf="isFixedColumn && !isRegistration && !isApplication && !isEnrollment">
            <label class="block mb-2 requiredValue">Lead Status</label>
            <p-select class="w-full shadow-none" appendTo="body" 
                [(ngModel)]="createFieldFormValue['lead_status']"
                name="lead_status" 
                [options]="leadStatusList"
                (onChange)="onStatusChange($event)">
            </p-select>
        </div>

        <!-- Lead Score - Only for Leads -->
        <div class="col-span-1" *ngIf="isLeads && !isRegistration && !isApplication">
            <label class="block mb-2">Lead Score</label>
            <input pInputText 
                class="w-full" 
                [(ngModel)]="createFieldFormValue['pipeline_score']"
                name="pipeline_score"
                disabled
                [style.opacity]="'0.6'"
                placeholder="Auto-filled based on status" />
        </div>

        <div class="col-span-1" *ngIf="isFixedColumn && isRegistration">
            <label class="block mb-2 requiredValue">Status</label>
            <p-select class="w-full shadow-none" appendTo="body"
                [(ngModel)]="createFieldFormValue['registration_status']" name="lead_status"
                [options]="registrationStatusList"></p-select>
        </div>

        <div class="col-span-1" *ngIf="isFixedColumn && isApplication">
            <label class="block mb-2 requiredValue">Application Status</label>
            <p-select class="w-full shadow-none" appendTo="body"
                [(ngModel)]="createFieldFormValue['application_status']" name="lead_status"
                [options]="applicationStatusList"></p-select>
        </div>

        <div class="col-span-1" *ngIf="isFixedColumn && isRegistration">
            <label class="block mb-2 requiredValue">Course</label>
            <p-select class="w-full shadow-none profile-select" appendTo="body"
                [(ngModel)]="createFieldFormValue['preferred_course']" name="preferred_course" [options]="courses"
                optionLabel="name" optionValue="course_id" required>
            </p-select>
        </div>

        <div class="col-span-1" *ngIf="isFixedColumn && isApplication">
            <label class="block mb-2 requiredValue">Course</label>
            <p-select class="w-full shadow-none profile-select" appendTo="body"
                [(ngModel)]="createFieldFormValue['preferred_course']" name="preferred_course" [options]="courses"
                optionLabel="name" optionValue="course_id" required>
            </p-select>
        </div>

    </div>


    <div *ngIf="isEnrollment" class="grid grid-cols-1 md:grid-cols-3 gap-6">

        <div class="col-span-1">
        <label class="block mb-2 requiredValue">Enrollment Status</label>
        <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['enrollment_status']"
            name="enrollment_status" [options]="enrollmentStatusList"></p-select>
        </div>

        <div class="col-span-1">
        <label class="block mb-2 requiredValue">Document Status</label>
        <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['document_status']"
            name="document_status" [options]="documentStatusList"></p-select>
        </div>

        <div class="col-span-1">
        <label class="block mb-2 requiredValue">Assigned To</label>
        <p-select appendTo="body" class="w-full" [(ngModel)]="createFieldFormValue['assigned_to']" name="assigned_to"
            [options]="users"></p-select>
        </div>

        <div class="col-span-1">
        <label class="block mb-2 requiredValue">Mode of Study</label>
        <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['mode_of_study']"
            name="mode_of_study" [options]="modeOfStudyList"></p-select>
        </div>

        <div class="col-span-1">
        <label class="block mb-2 requiredValue">Payment Status</label>
        <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['payment_status']"
            name="payment_status" [options]="paymentStatusList"></p-select>
        </div>

        <div class="col-span-1">
        <label class="block mb-2 requiredValue">Payment Mode</label>
        <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['payment_mode']"
            name="payment_mode" [options]="paymentModeList"></p-select>
        </div>

        <div class="col-span-1">
        <label class="block mb-2 requiredValue">Course</label>
        <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['preferred_course']"
            name="preferred_course" [options]="courses" optionLabel="name" optionValue="course_id" required>
        </p-select>
        </div>

        <div class="col-span-1">
        <label class="block mb-2 requiredValue">Source</label>
        <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['source']" name="source"
            [options]="leadSources"></p-select>
        </div>


    </div>


    <div *ngIf="isAdmission" class="grid grid-cols-1 md:grid-cols-3 gap-6">
       <div class="col-span-1">
            <label class="block mb-2 requiredValue">Academic Year</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['academic_year_id']"
                name="academic_year_id" [options]="academicYears" optionLabel="year_name" optionValue="id"></p-select>
        </div>

       <div class="col-span-1">
            <label class="block mb-2 requiredValue">Admission Mode</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['admission_mode']"
                name="admission_mode" [options]="admissionModes"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Admission Source</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['admission_source']"
                name="admission_source" [options]="admissionSources"></p-select>
        </div>

          <div class="col-span-1">
            <label class="block mb-2 requiredValue">Admission Status</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['admission_status']"
                name="admission_status" [options]="admissionStatusList"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Admission Type</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['admission_type']"
                name="admission_type" [options]="admissionTypes"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Assigned To</label>
            <p-select appendTo="body" class="w-full" [(ngModel)]="createFieldFormValue['assigned_to']" 
                name="assigned_to" [options]="users"></p-select>
        </div>

       

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Category</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['category']"
                name="category" [options]="categories"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Department</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['department_id']"
                name="department_id" [options]="departments"  optionLabel="name" optionValue="dept_id"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Hostel Category</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['hostel_category']"
                name="hostel_category" [options]="hostelCategories"
                optionLabel="hostel_name" optionValue="id"
                ></p-select>
        </div>

         <div class="col-span-1">
            <label class="block mb-2 requiredValue">Scholarship Category</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['scholarship_id']"
                name="scholarship_id" [options]="scholarshipTypes"  optionLabel="name" optionValue="scholarship_id"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Fee Group</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['fee_group_id']"
                name="fee_group_id" [options]="feeGroups" optionLabel="group_name" optionValue="id"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Transport Category</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['transport_category']"
                name="transport_category" [options]="transportCategories"
                optionLabel="route_name" optionValue="id"
                ></p-select>
        </div>

       <div class="col-span-1">
            <label class="block mb-2 requiredValue">Course</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['preferred_course']"
                name="preferred_course" [options]="courses" optionLabel="name" optionValue="course_id" required>
            </p-select>
        </div>


        <div class="col-span-1">
            <label class="block mb-2 requiredValue"> Batch</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['batch_id']" name="batch_id"
                [options]="batches" optionLabel="batch_name" optionValue="id"></p-select>
        </div>


           <div class="col-span-1">
            <label class="block mb-2 requiredValue">Approved By</label>
            <p-select appendTo="body" class="w-full" [(ngModel)]="createFieldFormValue['approved_by']"
                name="approved_by" [options]="users"></p-select>
        </div>

       <div class="col-span-1">
            <label class="block mb-2 requiredValue">Blood Group</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['blood_group']"
                name="blood_group" [options]="bloodGroups"></p-select>
        </div> 
    </div>

    <div *ngIf="isStudent" class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Academic Year</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['academic_year_id']"
                name="academic_year_id" [options]="academicYears" optionLabel="year_name" optionValue="id"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Course</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['course_id']"
                name="course_id" [options]="courses" optionLabel="name" optionValue="course_id"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Department</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['department_id']"
                name="department_id" [options]="departments" optionLabel="name" optionValue="dept_id"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Batch</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['batch_id']"
                name="batch_id" [options]="batches" optionLabel="batch_name" optionValue="id"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Caste Category</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['caste_category']"
                name="caste_category" [options]="categories"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Fee Group</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['fee_group_id']"
                name="fee_group_id" [options]="feeGroups" optionLabel="group_name" optionValue="id"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Hostel Category</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['hostel_category']"
                name="hostel_category" [options]="hostelCategories" optionLabel="hostel_name" optionValue="id"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Scholarship</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['scholarship_id']"
                name="scholarship_id" [options]="scholarshipTypes" optionLabel="name" optionValue="scholarship_id"></p-select>
        </div>

        <div class="col-span-1">
            <label class="block mb-2 requiredValue">Transport Category</label>
            <p-select class="w-full shadow-none" appendTo="body" [(ngModel)]="createFieldFormValue['transport_category']"
                name="transport_category" [options]="transportCategories" optionLabel="route_name" optionValue="id"></p-select>
        </div>
    </div>

    <div class="mt-4 flex justify-end gap-4">

        <p-button [label]="'Cancel'" [icon]="'pi pi-times'" variant="outlined" severity="danger"
            (click)="handleCloseDialog()"></p-button>

        <p-button [label]="'Update'" [icon]="'pi pi-pencil'" [disabled]="isLoading" [loading]="isLoading"
            (click)="onSubmit()" class="p-button-primary w-full md:w-auto"></p-button>
    </div>


</div>